import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav, Table } from "react-bootstrap";
import { Buttons } from "../components/Buttons";
import { useNavigate, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";
import { ExpenseExcel } from "./expenseexcel";
import { downloadPurchaseExcel } from "./purchaseexccel";
import { downloadSalesExcel } from "./salesexcel";
import { downloadStockExcel } from "./stockexcel";
import "../components/Table.css";
import { Calender, LoadingSpinner, DropDownUI } from "../components/Forms";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SaleRep from "../pages/SaleRep";
import PurchaseReport from "./PurchaseReport";
import StockPDF from "./StockPDF";
import ExpensePDF from "./expensepdf";
import moment from "moment";

const DOMAIN = "https://pskfancycrackers.com/api";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("Stock");
  const navigate = useNavigate();
  const [loadingStock, setLoadingStock] = useState(false);
  const [loadingSales, setLoadingSales] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [loadingExpense, setLoadingExpense] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [showLowStock, setShowLowStock] = useState(false);

  // Consolidated form data states
  const initialFormData = {
    party_id: "",
    product_id: "",
    category_id: "",
    fromdate: "",
    todate: "",
  };
  const [formDataSales, setFormDataSales] = useState({ ...initialFormData });
  const [formDataPurchase, setFormDataPurchase] = useState({
    ...initialFormData,
  });
  const [formDataStock, setFormDataStock] = useState({ ...initialFormData });
  const [formDataExpense, setFormDataExpense] = useState({
    ...initialFormData,
  });
  const [dropdownKey, setDropdownKey] = useState(Date.now());

  // Data states
  const [userDataSalesParty, setUserDataSalesParty] = useState([]);
  const [userDataPurchaseParty, setUserDataPurchaseParty] = useState([]);
  const [userDataProduct, setUserDataProduct] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [stockDataPurchase, setStockDataPurchase] = useState([]);
  const [stockDataProductSales, setStockDataProductSales] = useState([]);
  const [stockDataProductPurchase, setStockDataProductPurchase] = useState([]);
  const [productData, setProductData] = useState([]);
  const [expItemData, setExpItemData] = useState([]);
  const [expCategoryData, setExpCategoryData] = useState([]);

  // Generic date and form field handlers
  const setDate = (date, field, formSetter) => {
    formSetter((prev) => ({ ...prev, [field]: date }));
  };

  const setFormField = (value, field, formSetter) => {
    formSetter((prev) => ({ ...prev, [field]: value }));
  };

  const handleLowStockFilter = () => {
    setShowLowStock((prev) => !prev);
  };

  // Session check
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  // Sales data fetch
  const fetchAllSalesData = async () => {
    setLoadingSales(true);
    try {
      const companyId = localStorage.getItem("companyId");
      console.log("[DEBUG] Starting fetchAllSalesData. companyId:", companyId);
      // --------------------
      // Fetch Sales Parties
      // --------------------
      const salesPartyResponse = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "", company_id: companyId }),
      });
      const salesPartyData = await salesPartyResponse.json();
      console.log("[DEBUG] Sales Party API Response:", salesPartyData);

      if (salesPartyData.code === 200) {
        setUserDataSalesParty(salesPartyData.data);
      } else {
        throw new Error(salesPartyData.msg || "Failed to fetch sales parties");
      }
      // --------------------
      // Fetch Sales Invoices
      // --------------------
      const salesInvoiceResponse = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: "",
            party_name: "",
            party_id: "",
            from_date: "",
            to_date: "",
            bill_no: "",
          }),
        }
      );
      const invoiceData = await salesInvoiceResponse.json();
      console.log("[DEBUG] Invoice API Raw Response:", invoiceData);

      if (
        invoiceData &&
        invoiceData.status === 200 &&
        Array.isArray(invoiceData.data) &&
        invoiceData.data.length > 0
      ) {
        let sortedData = invoiceData.data;

        if (formDataSales.party_id) {
          sortedData = sortedData.filter(
            (item) => item.party_name === formDataSales.party_id
          );
          console.log("[DEBUG] Data after party_id filter:", sortedData);
        }

        if (formDataSales.fromdate) {
          const fromDate = moment(formDataSales.fromdate, "YYYY-MM-DD");
          sortedData = sortedData.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
          );
          console.log("[DEBUG] Data after from_date filter:", sortedData);
        }

        if (formDataSales.todate) {
          const toDate = moment(formDataSales.todate, "YYYY-MM-DD");
          sortedData = sortedData.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
          );
          console.log("[DEBUG] Data after to_date filter:", sortedData);
        }

        setStockData(sortedData);
        console.log("[DEBUG] Final data set to state:", sortedData);
      } else if (
        invoiceData &&
        invoiceData.code === 200 &&
        Array.isArray(invoiceData.data) &&
        invoiceData.data.length === 0
      ) {
        console.warn("[DEBUG] Invoice API returned empty data array.");
        setStockData([]);
      } else {
        console.error(
          "[DEBUG] Invoice API returned invalid data.",
          invoiceData
        );
        throw new Error(
          invoiceData.msg || "No sales data found or API returned invalid data"
        );
      }
    } catch (error) {
      console.error("Sales fetch error (catch block):", error.message);
      setStockData([]);
    } finally {
      setLoadingSales(false);
      console.log("[DEBUG] Finished fetchAllSalesData execution.");
    }
  };

  // Purchase data fetch
  const fetchAllPurchaseData = async () => {
    setLoadingPurchase(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const [partyRes, billRes] = await Promise.all([
        fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        }),
        fetch(`${API_DOMAIN}/purchase_bill.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const partyData = await partyRes.json();
      const billData = await billRes.json();

      if (partyData.status === 200) {
        setUserDataPurchaseParty(partyData.data);
      } else {
        throw new Error(partyData.msg || "Failed to fetch purchase parties");
      }

      if (billData && billData.data) {
        let filtered = billData.data;
        if (formDataPurchase.party_id) {
          filtered = filtered.filter(
            (item) => item.party_id === formDataPurchase.party_id
          );
        }
        if (formDataPurchase.fromdate) {
          const fromDate = moment(formDataPurchase.fromdate, "YYYY-MM-DD");
          filtered = filtered.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
          );
        }
        if (formDataPurchase.todate) {
          const toDate = moment(formDataPurchase.todate, "YYYY-MM-DD");
          filtered = filtered.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
          );
        }
        setStockDataPurchase(filtered);
      } else {
        throw new Error("No purchase data found");
      }
    } catch (err) {
      console.error("Purchase fetch error:", err.message);
      setStockDataPurchase([]);
    } finally {
      setLoadingPurchase(false);
    }
  };

  // Stock data fetch
  const fetchAllStockData = async () => {
    setLoadingStock(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const [productRes, salesRes, purchaseRes] = await Promise.all([
        fetch(`${DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
        fetch(`${API_DOMAIN}/salesinvoice.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: "",
            party_id: "",
            from_date: "",
            to_date: "",
          }),
        }),
        fetch(`${API_DOMAIN}/purchase_bill.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const productData = await productRes.json();
      const salesData = await salesRes.json();
      const purchaseData = await purchaseRes.json();
      console.log("productData", productData);
      if (productData.status === 200) {
        setUserDataProduct(productData.data);
        setProductData(productData.data);
      } else {
        throw new Error(productData.msg || "Failed to fetch products");
      }

      let filteredSales = salesData?.data || [];
      let filteredPurchase = purchaseData?.data || [];

      if (formDataStock.product_id) {
        filteredSales = filteredSales.filter((item) =>
          item.product.some((p) => p.product_id === formDataStock.product_id)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          item.product.some((p) => p.product_id === formDataStock.product_id)
        );
      }
      if (formDataStock.fromdate) {
        const fromDate = moment(formDataStock.fromdate, "YYYY-MM-DD");
        filteredSales = filteredSales.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
        );
      }
      if (formDataStock.todate) {
        const toDate = moment(formDataStock.todate, "YYYY-MM-DD");
        filteredSales = filteredSales.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
        );
      }

      setStockDataProductSales(
        filteredSales.map((item) => ({ ...item, type: "outward" }))
      );
      setStockDataProductPurchase(
        filteredPurchase.map((item) => ({ ...item, type: "inward" }))
      );
    } catch (error) {
      console.error("Stock fetch error:", error.message);
      setStockDataProductSales([]);
      setStockDataProductPurchase([]);
    } finally {
      setLoadingStock(false);
    }
  };

  // Expense data fetch
  const fetchAllExpenseData = async () => {
    setLoadingExpense(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const [categoryRes, itemRes] = await Promise.all([
        fetch(`${API_DOMAIN}/expensecategory.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
        fetch(`${API_DOMAIN}/expenseitem.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const categoryData = await categoryRes.json();
      const itemData = await itemRes.json();

      if (categoryData.status === 200) {
        setExpCategoryData(categoryData.data);
      } else {
        throw new Error(categoryData.msg || "Category fetch failed");
      }

      if (itemData.status === 200) {
        let filteredItems = itemData.data;
        if (formDataExpense.category_id) {
          filteredItems = filteredItems.filter(
            (item) => item.category_id === formDataExpense.category_id
          );
        }
        if (formDataExpense.fromdate) {
          const fromDate = moment(formDataExpense.fromdate, "YYYY-MM-DD");
          filteredItems = filteredItems.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
          );
        }
        if (formDataExpense.todate) {
          const toDate = moment(formDataExpense.todate, "YYYY-MM-DD");
          filteredItems = filteredItems.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
          );
        }
        setExpItemData(filteredItems);
      } else {
        throw new Error(itemData.msg || "Item fetch failed");
      }
    } catch (error) {
      console.error("Expense fetch error:", error.message);
      setExpItemData([]);
    } finally {
      setLoadingExpense(false);
    }
  };

  // Fetch data based on active tab
  useEffect(() => {
    if (activeTab === "sales") {
      fetchAllSalesData();
    } else if (activeTab === "purchase") {
      fetchAllPurchaseData();
    } else if (activeTab === "Stock") {
      fetchAllStockData();
    } else if (activeTab === "expense") {
      fetchAllExpenseData();
    }
  }, [
    activeTab,
    formDataSales,
    formDataPurchase,
    formDataStock,
    formDataExpense,
  ]);

  // Reset filters
  const handleClearFilters = (formSetter, initialData) => {
    formSetter({ ...initialData });
    setDropdownKey(Date.now());
    setShowLowStock(false);
  };

  // Render content based on active tab
  const renderContent = () => {
    if (loadingStock && activeTab === "Stock") {
      return <LoadingSpinner message="Loading Stock Report..." />;
    }
    if (loadingSales && activeTab === "sales") {
      return <LoadingSpinner message="Loading Sales Report..." />;
    }
    if (loadingPurchase && activeTab === "purchase") {
      return <LoadingSpinner message="Loading Purchase Report..." />;
    }
    if (loadingExpense && activeTab === "expense") {
      return <LoadingSpinner message="Loading Expense Report..." />;
    }

    switch (activeTab) {
      case "Stock":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="12">
                <div className="fw-bold fs-5 mb-3">
                  {showLowStock ? "Low Stock Report" : "Stock Report"}
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={userDataProduct.map((item) => ({
                    label: item.product_name,
                    value: item.product_id,
                  }))}
                  placeholder="Select Product"
                  labelname="Product"
                  name="product_id"
                  value={formDataStock.product_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.product_id,
                      "product_id",
                      setFormDataStock
                    )
                  }
                />
              </Col>
              <Col lg="2">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataStock)
                  }
                  selectedDate={formDataStock.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataStock)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="2">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) => setDate(date, "todate", setFormDataStock)}
                  selectedDate={formDataStock.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataStock)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="5" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataStock, { ...initialFormData })
                  }
                />
              </Col>
              <Col lg="2">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() => downloadStockExcel(productData)}
                />
              </Col>
              <Col lg="6">
                <Buttons
                  lable={<>Low Stock</>}
                  onClick={handleLowStockFilter}
                />
              </Col>
              <Col lg="4">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <StockPDF
                        data={
                          showLowStock
                            ? productData.filter(
                                (item) =>
                                  (parseFloat(item.crt_stock) || 0) <=
                                  (parseFloat(item.min_stock) || 0)
                              )
                            : productData
                        }
                        showLowStock={showLowStock}
                      />
                    }
                    fileName="StockReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="12" className="mt-3">
                <div className="wire-table table-scroll">
                  <Table responsive>
                    <thead>
                      {formDataStock.product_id ? (
                        <tr>
                          <th className="wrdbrk">S No</th>
                          <th className="wrdbrk">Date</th>
                          <th className="wrdbrk">Receipt No</th>
                          <th className="wrdbrk">Type</th>
                          <th className="wrdbrk">Product</th>
                          <th className="wrdbrk">Category</th>
                          <th className="wrdbrk">Stock</th>
                          <th className="wrdbrk">Sales Rate</th>
                        </tr>
                      ) : (
                        <tr>
                          <th className="wrdbrk">S No</th>
                          <th className="wrdbrk">Product Name</th>
                          <th className="wrdbrk">Category</th>
                          <th className="wrdbrk">Stock</th>
                          <th className="wrdbrk">Min Stock</th>
                          <th className="wrdbrk">Sales Rate</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {formDataStock.product_id
                        ? [
                            ...stockDataProductSales,
                            ...stockDataProductPurchase,
                          ]
                            .map((item) => ({
                              bill_date: item.bill_date,
                              bill_no: item.bill_no,
                              type:
                                item.type ||
                                (item.invoice_id ? "Sale" : "Purchase"),
                              product_name:
                                item.product?.[0]?.product_name || "N/A",
                              category:
                                item.product?.[0]?.category_name || "N/A",
                              stock: item.product?.[0]?.qty || 0,
                              sales_rate: item.product?.[0]?.price_unit || 0,
                            }))
                            .reverse()
                            .map((row, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.bill_date}</td>
                                <td>{row.bill_no}</td>
                                <td>{row.type}</td>
                                <td>{row.product_name}</td>
                                <td>{row.category}</td>
                                <td>{row.stock}</td>
                                <td>{row.sales_rate}</td>
                              </tr>
                            ))
                        : productData
                            .filter((item) =>
                              showLowStock
                                ? (parseFloat(item.crt_stock) || 0) <=
                                  (parseFloat(item.min_stock) || 0)
                                : true
                            )
                            .map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.product_name || "N/A"}</td>
                                <td>{item.category_name || "N/A"}</td>
                                <td>{item.crt_stock || 0}</td>
                                <td>{item.min_stock || 0}</td>
                                <td>{item.unit_rate || 0}</td>
                              </tr>
                            ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      case "sales":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    downloadSalesExcel(
                      stockData,
                      formDataSales.fromdate,
                      formDataSales.todate
                    )
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <SaleRep
                        data={stockData}
                        list={stockData}
                        fromdate={formDataSales.fromdate}
                        todate={formDataSales.todate}
                        partyid={formDataSales.party_id}
                      />
                    }
                    fileName="SaleReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={userDataSalesParty.map((item) => ({
                    label: item.party_name,
                    value: item.party_name,
                  }))}
                  placeholder="Select Party"
                  labelname="Party Name"
                  name="party_id"
                  value={formDataSales.party_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.party_id,
                      "party_id",
                      setFormDataSales
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataSales)
                  }
                  selectedDate={formDataSales.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataSales)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) => setDate(date, "todate", setFormDataSales)}
                  selectedDate={formDataSales.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataSales)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataSales, { ...initialFormData })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll">
                  <Table>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Bill No</th>
                        <th className="wrdbrk">Party Name</th>
                        <th className="wrdbrk">Phone Number</th>
                        <th className="wrdbrk">Product</th>
                        <th className="wrdbrk">HSN Code</th>
                        <th className="wrdbrk">Quantity</th>
                        <th className="wrdbrk">Sub Total</th>
                        <th className="wrdbrk">Tax Amount</th>
                        <th className="wrdbrk">Discount</th>
                        <th className="wrdbrk">Grand Total</th>
                        <th className="wrdbrk">Paid</th>
                        <th className="wrdbrk">Balance</th>
                        <th className="wrdbrk">Payment Method</th>
                        <th className="wrdbrk">Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(stockData || [])
                        .reduce((acc, item) => {
                          const products = item.product || [];
                          const taxAmount = products.reduce(
                            (sum, p) =>
                              sum +
                              parseFloat(p.CGST || 0) +
                              parseFloat(p.SGST || 0) +
                              parseFloat(p.IGST || 0),
                            0
                          );

                          acc.push({
                            bill_date: item.bill_date,
                            bill_no: item.bill_no,
                            party_name: item.party_name,
                            mobile_number: item.mobile_number,
                            products: products.map((p) => ({
                              name: p.product_name || "N/A",
                              hsn_no: p.hsn_no || "N/A",
                              qty: p.qty || "0",
                            })),
                            sub_total: item.sub_total,
                            tax_amount: taxAmount.toFixed(2),
                            discount: item.discount,
                            total: item.total,
                            paid: item.paid,
                            balance: item.balance,
                            payment_method: item.payment_method,
                            remark: item.remark,
                          });

                          return acc;
                        }, [])
                        .reverse()
                        .map((customer, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{customer.bill_date}</td>
                            <td>{customer.bill_no}</td>
                            <td>{customer.party_name}</td>
                            <td>{customer.mobile_number}</td>
                            <td>
                              {customer.products.map((p) => p.name).join(", ")}
                            </td>
                            <td>
                              {customer.products
                                .map((p) => p.hsn_no)
                                .join(", ")}
                            </td>
                            <td>
                              {customer.products.map((p) => p.qty).join(", ")}
                            </td>
                            <td>{customer.sub_total}</td>
                            <td>{customer.tax_amount}</td>
                            <td>{customer.discount}</td>
                            <td>{customer.total}</td>
                            <td>{customer.paid}</td>
                            <td>{customer.balance}</td>
                            <td>
                              {customer.payment_method &&
                                typeof customer.payment_method === "string" &&
                                customer.payment_method !== "[]" &&
                                JSON.parse(customer.payment_method)
                                  .map(
                                    (pm) =>
                                      `${pm.payment_method} - ${pm.amount}`
                                  )
                                  .join(", ")}
                            </td>
                            <td>{customer.remark}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      case "purchase":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    downloadPurchaseExcel(
                      stockDataPurchase,
                      formDataPurchase.fromdate,
                      formDataPurchase.todate
                    )
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <PurchaseReport
                        data={stockDataPurchase}
                        fromdate={formDataPurchase.fromdate}
                        todate={formDataPurchase.todate}
                      />
                    }
                    fileName="PurchaseReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={userDataPurchaseParty.map((item) => ({
                    label: item.party_name,
                    value: item.party_id,
                  }))}
                  placeholder="Select Party"
                  labelname="Party Name"
                  name="party_id"
                  value={formDataPurchase.party_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.party_id,
                      "party_id",
                      setFormDataPurchase
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataPurchase)
                  }
                  selectedDate={formDataPurchase.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataPurchase)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "todate", setFormDataPurchase)
                  }
                  selectedDate={formDataPurchase.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataPurchase)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataPurchase, {
                      ...initialFormData,
                    })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll">
                  <Table>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Bill No</th>
                        <th className="wrdbrk">Party Name</th>
                        <th className="wrdbrk">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(stockDataPurchase || [])
                        .map((item, index) => ({
                          bill_date: item.bill_date,
                          bill_no: item.bill_no,
                          party_name:
                            item.party_details?.party_name ||
                            item.party_name ||
                            "N/A",
                          total: item.total || 0,
                        }))
                        .reverse()
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.bill_date}</td>
                            <td>{row.bill_no}</td>
                            <td>{row.party_name}</td>
                            <td>{row.total}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      case "expense":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() => ExpenseExcel(expItemData, expCategoryData)}
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <ExpensePDF
                        data={expItemData}
                        category={expCategoryData}
                        fromdate={formDataExpense.fromdate}
                        todate={formDataExpense.todate}
                      />
                    }
                    fileName="ExpenseReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={expCategoryData.map((item) => ({
                    label: item.category_name,
                    value: item.category_id,
                  }))}
                  placeholder="Select Category"
                  labelname="Expense Category"
                  name="category_id"
                  value={formDataExpense.category_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.category_id,
                      "category_id",
                      setFormDataExpense
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataExpense)
                  }
                  selectedDate={formDataExpense.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataExpense)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "todate", setFormDataExpense)
                  }
                  selectedDate={formDataExpense.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataExpense)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataExpense, {
                      ...initialFormData,
                    })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll mt-3">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Expense Category</th>
                        <th className="wrdbrk">Expense Name</th>
                        <th className="wrdbrk">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(expItemData || [])
                        .map((item, index) => {
                          const category = expCategoryData.find(
                            (cat) => cat.category_id === item.category_id
                          );
                          return {
                            bill_date: item.bill_date || "N/A",
                            expense_name:
                              item.expense_name || item.party_name || "N/A",
                            amount: item.total || item.amount || 0,
                            category_name: category
                              ? category.category_name
                              : "Uncategorized",
                          };
                        })
                        .reverse()
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.bill_date}</td>
                            <td>{row.category_name}</td>
                            <td>{row.expense_name}</td>
                            <td>{row.amount}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      default:
        return null;
    }
  };

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="main my-2 stick-top">
              <div className="report-title py-3 mx-2">Transaction Reports</div>
              <div className="report">
                <Nav className="py-3">
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("Stock")}
                      className={
                        activeTab === "Stock" ? "navlink active" : "navlink"
                      }
                    >
                      Stock
                    </Nav.Link>
                  </li>
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("sales")}
                      className={
                        activeTab === "sales" ? "navlink active" : "navlink"
                      }
                    >
                      Sales
                    </Nav.Link>
                  </li>
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("purchase")}
                      className={
                        activeTab === "purchase" ? "navlink active" : "navlink"
                      }
                    >
                      Purchase
                    </Nav.Link>
                  </li>
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("expense")}
                      className={
                        activeTab === "expense" ? "navlink active" : "navlink"
                      }
                    >
                      Expense
                    </Nav.Link>
                  </li>
                </Nav>
              </div>
            </div>
          </Col>
          <Col lg="12" className="py-2">
            <div>{renderContent()}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reports;
